/**
 * Helper implementation for a provider of a single attribute whose value does not change.
 */
export class StaticAttributesProvider {
    constructor(attributeKey, value) {
        this.attributeKey = attributeKey;
        this.value = value;
    }
    // @ts-ignore
    getAttribute(attributeKey) {
        return this.value;
    }
    getProvidedAttributes() {
        const attributes = new Set();
        attributes.add(this.attributeKey);
        return attributes;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGljLWF0dHJpYnV0ZXMtcHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXR0cmlidXRlcy9zdGF0aWMtYXR0cmlidXRlcy1wcm92aWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTs7R0FFRztBQUNILE1BQU0sT0FBTyx3QkFBd0I7SUFFakMsWUFDWSxZQUErQixFQUMvQixLQUFVO1FBRFYsaUJBQVksR0FBWixZQUFZLENBQW1CO1FBQy9CLFVBQUssR0FBTCxLQUFLLENBQUs7SUFDbEIsQ0FBQztJQUVMLGFBQWE7SUFDYixZQUFZLENBQUksWUFBNkI7UUFDekMsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3RCLENBQUM7SUFFRCxxQkFBcUI7UUFDakIsTUFBTSxVQUFVLEdBQTJCLElBQUksR0FBRyxFQUFFLENBQUM7UUFDckQsVUFBVSxDQUFDLEdBQUcsQ0FBQyxJQUFJLENBQUMsWUFBWSxDQUFDLENBQUM7UUFDbEMsT0FBTyxVQUFVLENBQUM7SUFDdEIsQ0FBQztDQUNKIn0=